// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3goWv","rootCenter":"LoadMoreObserver_rootCenter__1LbV_","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3F_EZ"};